import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {FaEnvelopeOpenText} from 'react-icons/fa';
import {getNotifications, readNotification} from '../api';
import {useTranslation} from 'react-i18next';

const PendingInvitationAlerts = ({token, history}) => {
  const {t} = useTranslation();
  const [invitations, setInvitations] = useState([]);
  const refresh = useCallback(async () => {
    if (!token) return;
    const response = await getNotifications(token, 50);
    if (response.status === 200) {
      setInvitations((response.json.items || []).filter(item => item.type === 'booking_topup_invitation' && !item.actioned));
    }
  }, [token]);
  useEffect(() => { refresh(); }, [refresh]);
  if (!invitations.length) return null;
  const open = item => async () => {
    if (!item.read) await readNotification(item.id, token);
    history.push(item.actionUrl);
  };
  return <section className="pending-invitations-skywork" aria-label={t('INVITATIONS_TO_CONFIRM')}>
    <div className="pending-invitations-skywork__title"><FaEnvelopeOpenText/><div><small>{t('ACTION_REQUIRED')}</small><strong>{t('INVITATIONS_TO_CONFIRM_COUNT', {count: invitations.length})}</strong></div></div>
    {invitations.map(item => <div key={item.id} className="pending-invitations-skywork__item"><span><strong>{item.title}</strong><small>{item.body}</small></span><button type="button" onClick={open(item)}>{t('OPEN_INVITATION')}</button></div>)}
  </section>;
};
PendingInvitationAlerts.propTypes = {token: PropTypes.string, history: PropTypes.object.isRequired};
PendingInvitationAlerts.defaultProps = {token: null};
export default withRouter(connect(({login: {token}}) => ({token}))(PendingInvitationAlerts));
